import { render, staticRenderFns } from "./PoiCard.vue?vue&type=template&id=861c146c&scoped=true&"
import script from "./PoiCard.vue?vue&type=script&lang=js&"
export * from "./PoiCard.vue?vue&type=script&lang=js&"
import style0 from "./PoiCard.vue?vue&type=style&index=0&id=861c146c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861c146c",
  null
  
)

export default component.exports